export const GLOBAL_CONSTANTS = {
    SET_MODAL_TYPE: "SET_MODAL_TYPE",
    SET_MODAL_TAB: "SET_MODAL_TAB",
    SET_CONFIGURATION: "SET_CONFIGURATION",
    SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
    APPEND_NOTIFICATIONS: "APPEND_NOTIFICATIONS",
    SET_MODAL_CURRENCY: "SET_MODAL_CURRENCY",
    SET_GAME_PROVIDERS: "SET_GAME_PROVIDERS",
    SET_GAME_FULLSCREEN: "SET_GAME_FULLSCREEN",
    SET_NETWORKS: "SET_NETWORKS",
    SET_IN_PLAY: "SET_IN_PLAY",
    SET_SELECTED_CURRENCY: "SET_SELECTED_CURRENCY",
    SET_ACTIVE_LANGUAGE: "SET_ACTIVE_LANGUAGE",
    SET_USER_AGENT: "SET_USER_AGENT",
    SET_THEME: "SET_THEME",
    SET_SIDEBAR_SHOW: "SET_SIDEBAR_SHOW",
    SET_CHAT_SHOWN: "SET_CHAT_SHOWN",
    SET_HEADER_SEARCH_SHOWN: "SET_HEADER_SEARCH_SHOWN",
    SET_DEFAULT_SEARCH_GAMES: "SET_DEFAULT_SEARCH_GAMES",

};
